import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

import 'firebase/analytics'

if (environment.production) {
  enableProdMode();
  // ponytail: silences console output in prod builds; Angular 9's builder has no drop_console flag
  /* tslint:disable:no-empty */
  console.log = console.debug = console.info = console.warn = () => {};
  /* tslint:enable:no-empty */
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
